import { targetFactory } from '@ef-carbon/classification';
import Type from './Type';
export class DiscourseExpected {
    constructor({statement, suggestions, expected, hint, factory}) {
        this.type = Type.Expected;
        this.statement = factory(statement);
        this.suggestions = suggestions ? Array.from(suggestions, factory) : undefined;
        this.expected = Array.from(expected, targetFactory);
        this.hint = typeof hint === 'string' ? [hint] : hint ? Array.from(hint) : undefined;
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.writable = false;
        descriptors.type.configurable = false;
        descriptors.statement.configurable = false;
        descriptors.expected.configurable = false;
        descriptors.hint.configurable = false;
        Object.defineProperties(this, descriptors);
    }
}
export const klass = DiscourseExpected;
export {
    DiscourseExpected as Expected
};
export default DiscourseExpected;    //# sourceMappingURL=Expected.js.map
